module.exports = __webpack_public_path__ + "static/media/menu-financing-white.afaee93d.svg";